import useDate from '@/features/hooks/useDate';
import { renderIcon } from '@/utils/iconRenderer';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function DateSelection({ isShow, handleDateClick }) {
  const { t } = useTranslation();
  const { ilkTarih, sonTarih, setilkTarih, setSonTarih } = useDate();
  const [inputIlkTarih, setInputIlkTarih] = useState(ilkTarih);
  const [inputSonTarih, setInputSonTarih] = useState(sonTarih);
  const [inputDateValue, setInputDateValue] = useState('BuYil');

  function getLastWeeksDate(removingDate = 0) {
    const now = new Date();
    const getCurrentDate = new Date(
      now.getTime() - removingDate * 24 * 60 * 60 * 1000
    );
    if (removingDate === '30') {
      setInputIlkTarih(
        `${now.getFullYear()}-${('0' + (now.getMonth() + 1)).slice(-2)}-01`
      );
    } else if (removingDate === '7') {
      setInputIlkTarih(
        `${getCurrentDate.getFullYear()}-${(
          '0' +
          (getCurrentDate.getMonth() + 1)
        ).slice(-2)}-${('0' + getCurrentDate.getDate()).slice(-2)}`
      );
    } else if (removingDate === '365') {
      setInputIlkTarih(`${now.getFullYear()}-01-01`);
    } else {
      setInputIlkTarih(
        `${getCurrentDate.getFullYear()}-${(
          '0' +
          (getCurrentDate.getMonth() + 1)
        ).slice(-2)}-${('0' + getCurrentDate.getDate()).slice(-2)}`
      );
    }
    setInputSonTarih(
      `${now.getFullYear()}-${('0' + (now.getMonth() + 1)).slice(-2)}-${(
        '0' + now.getDate()
      ).slice(-2)}`
    );
  }

  function handleRadioChange(e) {
    setInputDateValue(e.target.value);
    switch (e.target.value) {
      case 'Bugun':
        getLastWeeksDate();
        break;
      case 'BuHafta':
        getLastWeeksDate(7);
        break;
      case 'BuAy':
        getLastWeeksDate(30);
        break;
      default:
        getLastWeeksDate(365);
        break;
    }
  }

  function handleClick() {
    setilkTarih(inputIlkTarih);
    setSonTarih(inputSonTarih);
    handleDateClick();
  }

  return (
    <>
      {/* Arkaplan gölgeleme alanı */}
      <div
        className={`fixed inset-0 bg-gray-900 bg-opacity-50 ${
          isShow ? 'block' : 'hidden'
        }`}
        onClick={handleDateClick}></div>

      {/* Tarih Seçim Modali */}
      <div
        className={`absolute top-16 left-4 right-5 max-w-lg mx-auto bg-white border border-gray-300 rounded-lg shadow-2xl p-4 popupMenu ${
          isShow ? 'block' : 'hidden'
        }`}>
        <div
          id="card-title"
          className="flex flex-row items-center justify-start justify-align-content-between  text-success-500 bg-color-header-menu gap-2 p-3 border ">
          {renderIcon('date', 28, 'text-gray-100')}
          <p className="ml-2 text-color-text-white text-lg font-semibold">
            {t('Tarih')}
          </p>
        </div>
        <div className="flex flex-col gap-4 my-5">
          {['Bugun', 'BuHafta', 'BuAy', 'BuYil'].map((value, idx) => (
            <div className="flex items-center gap-2" key={idx}>
              <input
                className="form-radio"
                type="radio"
                id={value}
                value={value}
                checked={inputDateValue === value}
                onChange={handleRadioChange}
              />
              <label htmlFor={value} className="text-gray-800">
                {t(value.charAt(0).toUpperCase() + value.slice(1))}
              </label>
            </div>
          ))}
          <div className="flex justify-between mt-4">
            <input
              type="date"
              className="w-1/2 p-2 border border-gray-300 rounded"
              value={inputIlkTarih}
              onChange={(e) => {
                setInputIlkTarih(e.target.value);
                setInputDateValue('');
              }}
            />
            <input
              type="date"
              className="w-1/2 p-2 border border-gray-300 rounded ml-2"
              value={inputSonTarih}
              onChange={(e) => {
                setInputSonTarih(e.target.value);
                setInputDateValue('');
              }}
            />
          </div>

          <button
            className="flex items-center justify-center bg-color-button text-white w-full py-2  shadow hover:bg-color-button-hover rounded transition-colors duration-300"
            type="submit"
            onClick={handleClick}>
            {renderIcon('domain-verification', 28, 'text-white')}
            <p className="text-sm px-1">{t('Ok')}</p>
          </button>
        </div>
      </div>
    </>
  );
}

export default DateSelection;
